import { render, staticRenderFns } from "./colour.vue?vue&type=template&id=dc11f88a&scoped=true&"
import script from "./colour.vue?vue&type=script&lang=js&"
export * from "./colour.vue?vue&type=script&lang=js&"
import style0 from "./colour.vue?vue&type=style&index=0&id=dc11f88a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc11f88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc11f88a')) {
      api.createRecord('dc11f88a', component.options)
    } else {
      api.reload('dc11f88a', component.options)
    }
    module.hot.accept("./colour.vue?vue&type=template&id=dc11f88a&scoped=true&", function () {
      api.rerender('dc11f88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/colour.vue"
export default component.exports